import type { FaireProductEntity } from "../../entity_types/product";

export const p_xq7fhjdasy: FaireProductEntity = {
  token: "p_xq7fhjdasy",
  type: "product",
  name: "Dainty 4mm Faceted Garnet beads + Genuine Copper bracelet",
  brandToken: "b_r3cuwn57s4",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/87d8503ecc1861362a5d9f604f6dfcf5820ac64892df3f43f58177c0a14269cd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/177f2dbde262d22f797f1eaf74d0f7dd453384fba29bd7ae07169cb4c1ce3391.png",
    "https://cdn.faire.com/fastly/8666bd6e92f7f8da1b99b35467cfc288ce0142177b7dacf2e4c81f6cfa8defcf.png",
    "https://cdn.faire.com/fastly/ebb4afcd83e1ca3438f4c9cc166346d463dc3694d5d4fd3df7c73bd8e00cc691.jpeg",
    "https://cdn.faire.com/fastly/9710a3d9edfa604a213e70d40a91968469ee85107f05de6866c03443ce587e10.jpeg",
    "https://cdn.faire.com/fastly/4e328e228c6c498b612fdb84c35a4ff7bcb2b74e5766620573d3a8899acc1b95.jpeg",
    "https://cdn.faire.com/fastly/3006a783fdf2f593a24d9567a4bf2e53eb53bc4988fe7e07d0ffbe759b4cc354.jpeg",
    "https://cdn.faire.com/fastly/67d244809b52ef10d0146990fa3b5e37f3621cdd7ec4d7a1d03460104aba169a.jpeg"
  ],
  priceDollars: 19.4,
  description: "\nFits most wrist. Size 6.5 - 7\"\n\nDainty and Minimal Stretchy bracelets with multi-faceted 4mm Garnet + 3mm Solid copper beads Every bracelet comes with a tag that lists the properties of the gemstones and copper and is packed in a cotton pouch. Purported benefits of wearing a copper bracelet include the following: Relieves pain and inflammation caused by arthritis. Sterilizes wounds (due to its antibacterial properties) Improves the immune system. Works as an antioxidant. Prevents cardiovascular disease.\n",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:44.341Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
